var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"hero has-text-centered"},[_c('p',{staticClass:"is-cs-3 has-text-weight-bold"},[_vm._v("イベント・ポップアップストアの"),_c('br'),_vm._v("お品書きを手軽に作成＆シェア！")]),_vm._v(" "),_c('h1',[_c('i',{staticClass:"c-icon cachalog-logo"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69437266","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/view/lp/hero.vue
// module id = null
// module chunks = 